const STORE_KEY = 'studio-hide'

export function getHideParams () {
  const params = window.sessionStorage.getItem(STORE_KEY) || 'null'
  return JSON.parse(params)
}

export function setHideParams (params) {
  return window.sessionStorage.setItem(STORE_KEY, JSON.stringify(params))
}
